import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { AuthStateService } from '../core/auth/auth-state.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrl: './app.topbar.component.scss',
})
export class AppTopBarComponent {

    items!: MenuItem[];

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    userName!: String;

    menuItems: any[] = [];

    currentRoute: string;

    constructor(public layoutService: LayoutService, private authStateService: AuthStateService, private router: Router, private activatedRoute: ActivatedRoute) {
        this.activatedRoute.url.subscribe(urlSegments => {
            
            this.currentRoute = urlSegments.map(segment => segment.path).join('/');
          });

    }

    ngOnInit(): void {
        this.userName = this.getLoggedInUsername();
        this.menuItems = [
            {
                label: 'Logout',
                icon: 'pi pi-sign-out',
                command: () => {
                    this.logoutSelected();
                }
            },
            {
                label: 'Password Reset',
                icon: 'pi pi-lock',
                command: () => {
                    this.resetPasswordClicked()
                }
            }
        ]
    }

    getLoggedInUsername(): string {
        const user = this.authStateService.getLoggedInUser();
        return user.given_name + " " + user.family_name;
    }

    logoutSelected(): void {
        this.authStateService.clearStorage();
        this.router.navigate(['/']);
    }

    resetPasswordClicked() {
        this.resetPassword(this.currentRoute);
    }

    resetPassword(data: string): void {
        this.router.navigate(['/password-reset'], { queryParams: { data: JSON.stringify(data) } })
    }
}
